<template>
  <div>
    <!-- Exercise column -->
    <v-col cols="12">
      <exercise-logic-multiple
        exCollection="archetypesExCollection"
        @ready="onReady"
        @error="onError"
        @saved="onSaved"
        @savedNext="onSavedNext"
        @loadedEx="onLoadedEx"
        @loadedRef="onLoadedRef"
        @modifyEx="onModifyEx"
        :doc="doc"
        :pid="true"
        :shared="false"
      >
        <template slot-scope="{ saveExercise }">
          <v-stepper v-model="e1">
            <v-stepper-header>
              <template v-for="tab in tabs">
                <v-stepper-step
                  :key="`tab${tab.count}`"
                  color="amber"
                  :complete="e1 > tab.count"
                  :step="tab.count"
                  @click="el = tab.count"
                  >{{ tab.title }}</v-stepper-step
                >
                <v-divider :key="`divider${tab.count}`"></v-divider>
              </template>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content
                v-for="tab in tabs"
                :key="`tab${tab.count}`"
                :step="tab.count"
              >
                <component
                  :is="tab.component"
                  v-model="doc[tab.model]"
                  :list="refs"
                  :exercise="exercise"
                  :doc="doc"
                  :selected-list="selectedList"
                />

                <bottom-navigation
                  :save="tab.save"
                  :next="tab.next"
                  :prev="tab.prev"
                  :gridView="false"
                  :gridToggle="false"
                  @save="saveExercise(true)"
                  @prev="prevStep"
                  @next="nextStep"
                >
                </bottom-navigation>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </template>
      </exercise-logic-multiple>
    </v-col>
    <pre>{{ selectedList }}</pre>
    <v-dialog v-model="dialog" max-width="800">
      <v-card>
        <v-card-title
          class="headline"
          v-text="$t('exercise_service.saved.title')"
        ></v-card-title>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="amber" text @click="closeDialog">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
// @ is an alias to /src
import lodash from "lodash";
import { mapState } from "vuex";
import { BottomNavigation } from "@/components/core";
import { ExerciseLogicMultiple } from "@/components/exercises";
import {
  ArchetypesTiles,
  ArchetypesTable,
} from "@/views/user/exercises/archetypes";

const fb = require("@/firebaseConfig.js");

export default {
  name: "UserTravel",
  data() {
    return {
      e1: 1,
      exercise: null,
      dialog: false,
      dialogMode: "add",
      doc: {},
      refs: [],
      ready: false,
      selectedList: [],
      debug: false,
    };
  },
  components: {
    BottomNavigation,
    ExerciseLogicMultiple,
    ArchetypesTiles,
    ArchetypesTable,
  },
  computed: {
    ...mapState([
      "userProfile",
      "currentUser",
      "currentProject",
      "currentProjectModel",
    ]),
    tabs() {
      return [
        {
          title: "Choose a character",
          count: 1,
          component: ArchetypesTiles,
          model: "archetype",
          items: this.refs,
          next:
            this.doc && this.doc.archetype && this.doc.archetype.length
              ? true
              : false,
          prev: true,
          save: false,
        },
        {
          title: "Choose an archetype",
          count: 2,
          component: ArchetypesTable,
          model: "type",
          doc: this.doc,
          next: false,
          prev: true,
          save: true,
        },
      ];
    },
  },
  mounted() {
    this.loadTiles();
  },
  methods: {
    loadTiles() {
      fb.archetypesCollection
        .orderBy("createdOn", "desc")
        .onSnapshot((querySnapshot) => {
          let items = [];
          querySnapshot.forEach((doc) => {
            let post = doc.data();
            items.push(post);
          });
          this.refs = lodash.orderBy(items, "name", "asc");
        });
    },
    nextStep() {
      this.e1++;
    },
    prevStep() {
      this.e1--;
    },
    onReady() {},
    onError() {
      console.log("error");
    },
    onSaved() {
      this.dialog = true;
    },
    onLoadedRef(items) {
      console.log("loaded refs", items);
      this.refs = items;
    },
    onLoadedEx(items) {
      console.log("loaded exercise", items);
      this.exercise = items[0];
      if (this.exercise.doc.archetype && this.exercise.doc.archetype.length) {
        this.selectedList.length = 0;
        this.selectedList.push(this.exercise.doc.archetype[0].id);
      }
    },
    onModifyEx(items) {
      this.exercise = items[0];
    },
    onSavedNext() {
      this.nextStep();
    },
    closeDialog() {
      this.dialog = false;
    },
  },
};
</script>

<style lang="scss"></style>
